export const GET_EXAM_ROOMS            = "api/v1/exam-rooms";
export const ADD_NEW_EXAM_ROOM = "/exam-rooms";
export const UPDATE_EXAM_ROOM = "/exam-rooms";
export const DELETE_EXAM_ROOM = "/exam-rooms";





//export const EXAM_ROOM_ASSIGNMENTS = "/exam-room-assignments";
export const CHECK_AVAILABILITY    = "/exam-rooms/check-availability";